import {Component, EventEmitter, inject, OnDestroy, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {Doctor} from 'src/app/modules/doctor-repository/entities/doctor';
import {DoctorRepositoryService} from 'src/app/modules/doctor-repository/doctor-repository.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SelectOption} from '../../../shared/interfaces/select-option';

@Component({
  selector: 'app-doctor-edit-card',
  standalone: false,
  templateUrl: './doctor-edit-card.component.html',
  styleUrl: './doctor-edit-card.component.scss'
})
export class DoctorEditCardComponent implements OnInit, OnDestroy {

  private dialogRef = inject(MatDialogRef<DoctorEditCardComponent>);
  private formBuilder = inject(UntypedFormBuilder);
  private doctorRepository = inject(DoctorRepositoryService);
  private doctor = inject<Doctor>(MAT_DIALOG_DATA);

  private repositorySubscription: Subscription;
  validate = false;
  form: UntypedFormGroup;

  @Output() doctorSaved: EventEmitter<Doctor> = new EventEmitter();

  contactMethodOptions: SelectOption[] = [
    { value: 'Phone', text: 'Phone'},
    { value: 'Email', text: 'Email'},
    { value: 'Fax', text: 'Fax'}
  ];

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: [this.doctor?.name || '', Validators.required],
      practiceNumber: [this.doctor?.practiceNumber || ''],
      tel: [this.doctor?.tel || ''],
      fax: [this.doctor?.fax || ''],
      email: [this.doctor?.email || ''],
      preferredGreeting: [this.doctor?.preferredGreeting || ''],
      preferredContactMethod: [this.doctor?.preferredContactMethod || '']
    });
  }

  ngOnDestroy(): void {
    if (this.repositorySubscription) { this.repositorySubscription.unsubscribe(); }
  }

  save() {
    if (this.form.valid) {
      const updatedDoctor = this.formToDoctor();
      this.repositorySubscription = this.doctorRepository.updateDoctor(this.doctor.id, updatedDoctor).subscribe(result => {
        this.dialogRef.close(updatedDoctor);
        this.doctorSaved.emit(updatedDoctor);
      });
    }
    console.log(this.form.errors);
    this.validate = true;
  }

  close() {
    this.dialogRef.close();
  }

  private formToDoctor(): Doctor {
    return {
      ...this.doctor,
      ...this.form.value
    } as Doctor;
  }
}
